import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Switch } from "@/components/ui/switch";
import { PRIVACY } from "@/lib/content";
import { readConsent, saveConsent } from "@/lib/cookieConsent";
import { ease } from "./motion";

export const CookieBanner = () => {
  const [show, setShow] = useState(() => !readConsent());
  const [custom, setCustom] = useState(false);
  const [analytics, setAnalytics] = useState(true);

  const save = (value) => { saveConsent(value); setShow(false); };

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          data-testid="cookie-banner"
          initial={{ y: 120, opacity: 0 }}
          animate={{ y: 0, opacity: 1, transition: { duration: 0.8, ease, delay: 2.2 } }}
          exit={{ y: 120, opacity: 0, transition: { duration: 0.4 } }}
          className="fixed bottom-4 left-4 right-4 sm:left-auto sm:right-6 sm:bottom-6 sm:max-w-md z-[55] rounded-2xl bg-[#FAF8F5]/95 backdrop-blur-xl border border-[#0F5A47]/15 p-5 shadow-[0_20px_60px_-20px_rgba(8,47,36,0.45)]"
        >
          <p className="font-display text-xl text-[#082F24]">Your Privacy Matters</p>
          <p className="mt-2 text-sm text-[#52635B] leading-relaxed">
            We use cookies to enhance your browsing experience, analyze site traffic, and personalize content. By clicking "Accept All", you consent to our use of cookies as detailed in our{" "}
            <a href={PRIVACY} data-testid="cookie-privacy-link" target="_blank" rel="noopener noreferrer" className="underline text-[#0F5A47]">Privacy Policy</a>.
          </p>
          {custom && (
            <div className="mt-4 space-y-3 text-sm text-[#1A2520]">
              <label className="flex items-center justify-between">Essential cookies <Switch data-testid="cookie-essential-switch" checked disabled /></label>
              <label className="flex items-center justify-between">Analytics cookies <Switch data-testid="cookie-analytics-switch" checked={analytics} onCheckedChange={setAnalytics} /></label>
            </div>
          )}
          <div className="mt-4 flex gap-2">
            <button data-testid="cookie-accept-btn" onClick={() => save("all")} className="rounded-full bg-[#082F24] px-5 py-2.5 text-sm font-semibold text-[#FAF8F5] hover:bg-[#0F5A47] transition-colors">Accept All</button>
            {custom ? (
              <button data-testid="cookie-save-btn" onClick={() => save(analytics ? "all" : "essential")} className="rounded-full border border-[#082F24]/25 px-5 py-2.5 text-sm font-semibold text-[#082F24] hover:bg-[#082F24]/5 transition-colors">Save choices</button>
            ) : (
              <button data-testid="cookie-customize-btn" onClick={() => setCustom(true)} className="rounded-full border border-[#082F24]/25 px-5 py-2.5 text-sm font-semibold text-[#082F24] hover:bg-[#082F24]/5 transition-colors">Customize</button>
            )}
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
